<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="table-container">
<table mat-table [dataSource]="scenarioDataSource" matSort multiTemplateDataRows>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      @if (permissions.includes(SystemPermission.CreateScenarios)) {
      <button mat-icon-button (click)="editScenario(null); $event.stopPropagation()"
        style="outline: none; margin-left: 20px;" title="Add Scenario">
        <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
      </button>
      }
    </th>
    <td mat-cell *matCellDef="let element">
      @if (permissions.includes(SystemPermission.CreateScenarios)) {
      <button mat-icon-button ngxClipboard [cbContent]="element.id" (click)="$event.stopPropagation()"
        style="outline: none;" title="Copy ID:  {{ element.id }}">
        <mat-icon class="mdi-18px" fontIcon="mdi-content-copy"></mat-icon>
      </button>
      }
      @if (canDoSomething(element)) {
      <button mat-icon-button (click)="onContextMenu($event, element); $event.stopPropagation()" style="outline: none;"
        title="Scenario Menu">
        <mat-icon class="mdi-18px" fontIcon="mdi-menu"></mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="view">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>View</th>
    <td mat-cell *matCellDef="let element">{{ element.view }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element">
      @if (!!element.view || element.status !== 'ready') {
        {{ element.status }}
      }
      @if (!element.view && element.status === 'ready') {
        <span class="warn-text">Select a view!</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Start</th>
    <td mat-cell *matCellDef="let element">{{ element.startDate | date: 'yyyy-MM-dd HH:mm' }}</td>
  </ng-container>

  <ng-container matColumnDef="endDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>End</th>
    <td mat-cell *matCellDef="let element">{{ element.endDate | date: 'yyyy-MM-dd HH:mm' }}</td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
      <div [@detailExpand]="element.id === expandedScenarioId ? 'expanded' : 'collapsed'"
        (click)="$event.stopPropagation()">
        @if (element.id === expandedScenarioId) {
          @if (adminMode) {
          <div class="memberships-container">
            <label class="memberships-label">Memberships</label>
            <app-scenario-memberships [scenarioId]="element.id" [showHeader]="false"></app-scenario-memberships>
          </div>
          } @else {
          <app-scenario-edit [scenario]="selectedScenario"></app-scenario-edit>
          }
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"
    (click)="selectScenario($event, row.id)" (contextmenu)="onContextMenu($event, row)"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>
</div>

@if (isLoading) {
<div class="cssLayoutRowStartCenter">
  <div flex>
    <mat-progress-spinner color="accent" mode="indeterminate">
    </mat-progress-spinner>
  </div>
</div>
}

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    @if (canEdit(item)) {
    <button mat-menu-item (click)="editScenario(item)">
      Edit
    </button>
    }
    @if (permissions.includes(SystemPermission.CreateScenarios)) {
    <button mat-menu-item (click)="copyScenario(item)">
      Copy
    </button>
    }
    @if (item.status === 'ready' && !!item.viewId && canExecute(item)) {
    <button mat-menu-item (click)="startScenario(item)">
      Start
    </button>
    }
    @if (item.status === 'active' && canExecute(item.id)) {
    <button mat-menu-item (click)="endScenario(item)">
      End
    </button>
    }
    @if (canManage(item)) {
    <button mat-menu-item (click)="deleteScenario(item)">
      Delete
    </button>
    }
  </ng-template>
</mat-menu>
